export default {
    getSelectedSideBar: state => state.selectedSideBar,
}